import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function deriveModuleState(startFlag, completeFlag) {
    if (startFlag === null)
        return "dormant";
    if (startFlag === true && completeFlag === null)
        return "active";
    return "completed";
}
export function ModuleShell({ title, description, startFlag, completeFlag, activeContent, completedContent, theme = "governance", }) {
    const state = deriveModuleState(startFlag, completeFlag);
    if (state === "dormant")
        return null;
    const isGovernance = theme === "governance";
    const containerStyle = {
        background: state === "completed"
            ? isGovernance
                ? "var(--panel-soft)"
                : "rgba(255,255,255,0.03)"
            : isGovernance
                ? "var(--panel)"
                : "var(--panel, #111827)",
        border: "1px solid var(--border)",
        borderRadius: "var(--radius)",
        padding: "24px 28px",
        position: "relative",
    };
    return (_jsxs("section", { style: containerStyle, "aria-label": `Module: ${title}`, children: [_jsxs("header", { style: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    marginBottom: 20,
                }, children: [_jsxs("div", { children: [_jsx("h3", { style: {
                                    margin: 0,
                                    fontSize: 17,
                                    fontWeight: 800,
                                    color: isGovernance ? "var(--ink)" : "var(--text, #e5e7eb)",
                                }, children: title }), description && state === "active" && (_jsx("p", { style: {
                                    margin: "4px 0 0",
                                    fontSize: 13,
                                    color: "var(--muted)",
                                }, children: description }))] }), state === "completed" && (_jsx("span", { "aria-label": "Module completed", style: {
                            padding: "4px 12px",
                            borderRadius: 999,
                            fontSize: 11,
                            fontWeight: 700,
                            textTransform: "uppercase",
                            letterSpacing: "0.05em",
                            background: isGovernance
                                ? "var(--good-bg)"
                                : "rgba(34,197,94,0.15)",
                            color: isGovernance ? "var(--good)" : "#22c55e",
                        }, children: "Completed" }))] }), state === "active" ? activeContent : completedContent] }));
}
//# sourceMappingURL=ModuleShell.js.map